import { useContextState } from '../../../../../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {
    tabsContainer: {
      position: 'relative',
      paddingBottom: '20px'
    },
    action: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      }
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    areaTitle: {
      fontSize:'12px',
      color: colors.color10,
      display:'flex',
      alignItems: 'center'
    },
    users: {
      textAlign: 'end',
      paddingRight: '5px',
    },
    headetText: {
      color: colors.color5,
      fontWeigt: '800',
      fontSize: '12px',
    },
    checkLabel: {
      color: colors.color5,
      fontWeigt: '800',
      fontSize: '12px',
      maxWidth: '120px',
      wordBreak: 'break-word'
    },
    containerUnit: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    unitContent: {
      fontSize: '12px',
      color: colors.color9,
      width: '100%',
    },
    user: {
      fontSize: '12px',
      color: colors.color9,
      width: '100%',
    },
    containerIconTooltip: {
      height: '15px',
    },
    bodyText: {
      color: colors.color10,
      fontWeigt: '800',
      fontSize: '12px',
      wordBreak: 'break-all',
      maxHeight: '40px',
      textAlign: 'center',
      // textWrap: 'nowrap',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
      // width: '50px'
    },
    label: {
      '& .MuiFormControlLabel-label': {
        wordBreak: 'break-word',
        fontSize: '12px',
      },
    },
    all: {
      display: 'flex',
      alignItems: 'center',
      '& .remove-m': {
        margin: '0px'
      }
    },
    setting: {
      display: 'flex',
      justifyContent: 'center',
      '& .MuiButton-root': {
        fontSize: '10px',
        color: colors.color4,
      },
      '& .delete': {
        color: colors.color12,
      }
    },
    TabList: {
      width: '100%',
      //paddingRight: '50px',
      '& .MuiTabs-flexContainer': {
        paddingTop: '5px',
        columnGap: '10px',
        justifyContent: 'end',
        paddingRight: '2px',
      },
      '& .MuiTab-root': {
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        backgroundColor: `transparent`,
        color: colors.color10,
        '& .MuiTabs-scroller': {
          overflow: 'auto',
        },
        '&.Mui-selected': {
          /* backgroundColor: `${colors.color5}`, */
          color: colors.primary,
          /* boxShadow: `0 0 4px ${colors.color10}`, */
          fontWeight: '600'
        },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
    },
    TabPanel: {
      '&.MuiTabPanel-root': {
        boxShadow: `0 0 4px ${colors.color13}`,
        borderRadius: '10px',
        width: '100%',
        // height: '100%',
        // paddingBottom: '0px',
      },
    },
  }
}

export { useStyles }
